import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/content";

export default function ComplaintsProcedure() {
  const sections = [
    {
      heading: "What we consider a complaint",
      paragraphs: [
        "A complaint is any expression of dissatisfaction about our fundraising, our fundraisers, or the way we have engaged with a member of the public \u2014 whether it relates to a specific incident or to our conduct more generally.",
      ],
    },
    {
      heading: "How to complain",
      paragraphs: [
        `You can raise a complaint through our Contact form (select \u201cComplaint\u201d) or by emailing our monitored public address at ${COMPANY.email}.`,
      ],
    },
    {
      heading: "Information that helps us investigate",
      paragraphs: ["Where possible, please include:"],
      list: [
        "Your contact details",
        "The date of the incident",
        "The location",
        "The charity or campaign concerned",
        "The fundraiser's details, if known",
        "What happened",
        "The outcome you are seeking",
      ],
    },
    {
      heading: "How we handle your complaint",
      paragraphs: [
        "We will acknowledge your complaint within five working days.",
        "We aim to provide a full response within 20 working days. If we need more time, we will explain why and give you an update.",
        "Complaints are investigated thoroughly and fairly and, where practicable, by someone suitably independent of the matter.",
      ],
    },
    {
      heading: "If you are dissatisfied with our response",
      paragraphs: [
        "If you are not satisfied with our response, you may request that a director of Amanah Promotions reviews your complaint.",
      ],
    },
    {
      heading: "Sharing with charity partners",
      paragraphs: [
        "Where a complaint concerns fundraising carried out on behalf of a charity, we may share relevant details with that charity partner where necessary to investigate and respond.",
      ],
    },
    {
      heading: "Referring your complaint further",
      paragraphs: [
        "If your complaint about charitable fundraising remains unresolved, you may be able to refer it to the Fundraising Regulator, subject to its remit and its requirement that the organisation is first given a reasonable opportunity to respond.",
      ],
    },
    {
      heading: "Learning from complaints",
      paragraphs: [
        "We review complaint records and any lessons learned so that we can continually improve our future fundraising.",
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Complaints"
      title="Fundraising Complaints Procedure"
      intro="How to raise a complaint about our fundraising, and how Amanah Promotions will handle it."
      updated="8 August 2026"
      sections={sections}
    />
  );
}
